export default __webpack_public_path__ + "b0d726f6fa3b4e03fb620ddd8ebe88f9.png";